module.exports = __webpack_public_path__ + "static/og-image-26c403fc8947e840bceb6ec83d41e6fc.jpg";